import { useMemo } from 'react';
import { css } from '@emotion/react';

import { useWidgetContext } from '@widget/core';
import { SlideOver, AnimationDirection } from '@toolbox/transition';
import { usePrevious } from '@toolbox/hooks';
import { useTheme } from '@toolbox/style';

import type { ReactNode } from 'react';

export interface StepSlideTransitionProps {
  children: ReactNode;
}

const slideStyles = css`
  margin: 0 auto;
`;

export function StepSlideTransition({ children }: StepSlideTransitionProps): JSX.Element {
  const { activeId, history } = useWidgetContext();
  const previousId = usePrevious(activeId);

  const direction: AnimationDirection = useMemo(() => {
    return previousId &&
      history.findIndex(({ id }) => id === activeId) >
        history.findIndex(({ id }) => id === previousId)
      ? AnimationDirection.RIGHT
      : AnimationDirection.LEFT;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeId]);

  const theme = useTheme();

  return (
    <SlideOver
      css={slideStyles}
      transitionKey={activeId}
      direction={direction}
      appearBg={theme.palette.bg.default}
    >
      {children}
    </SlideOver>
  );
}
